import React from "react";
import Actions from "../Table/TableAction";
import Tooltip from "@mui/material/Tooltip";

interface cardProps {
  image: any;
  firstname: string;
  lastname: string;
  phone: string | number;
  position: string;
  id: string | number;
  department: string;
  email: string;
  date: any;
  city: string;
  country: string;
  status: string;
  lead: string;
  employment_type: string;
  handleDelete: (id: any) => void;
  handleClick?: (id: any) => void;
  handleActive?: (id: any) => void;
}

const ContactCard: React.FC<cardProps> = ({
  image,
  firstname,
  lastname,
  position,
  id,
  department,
  email,
  date,
  phone,
  city,
  country,
  status,
  lead,
  employment_type,
  handleDelete,
  handleClick,
  handleActive,
}) => {
  const data = {
    image: image,
    name: firstname,
    lastname: lastname,
    job_role: position,
    id: id,
    department: department,
    email: email,
    datejoined: date,
    phone: phone,
    city: city,
    country: country,
    status: status,
    lead: lead,
    employment_type: employment_type,
  };
  return (
    <div className="bg-lighterGray1 shadow-white shadow-2xl rounded-xl py-4 px-2 hover:bg-[#fbc2c2] transition-all duration-900  hover:translate-y-1 flex flex-col justify-between">
      <div>
        <div className="flex flex-col">
          <img
            src={image}
            alt={firstname}
            className="h-[60px] w-[60px] rounded-lg"
          />
        </div>
        <div className="flex flex-row justify-between items-center mb-3">
          <div className="flex flex-col">
            <span className={` text-black text-xl`}>
              {firstname} {lastname}
            </span>
            <span className={`text-[#6F6F6F] font-bold text-sm `}>
              {position}
            </span>
          </div>
          <div className={` text-black`}>
            <Actions
              handleDelete={() => handleDelete(id)}
              handleActive={() => handleActive && handleActive(data)}
              handleClick={() => handleClick && handleClick(data)}
              active={status}
            />
          </div>
        </div>
      </div>
      <div className="bg-white  rounded-xl p-2 shadow-md mt-auto">
        <div className="flex flex-row justify-between mb-4">
          <div className="flex flex-col">
            <span className={`text-[#6F6F6F] font-bold text-sm `}>
              Department
            </span>
            <span className={` text-lightDark`}> {department}</span>
          </div>
          <div className="flex flex-col justify-between">
            <span className={`text-[#6F6F6F] font-bold text-sm  text-right`}>
              Date Joined
            </span>
            <span className={` text-lightDark`}>{date}</span>
          </div>
        </div>
        <div className="flex flex-col justify-between">
          <div className="flex flex-row justify-between">
            <div className="w-24">
              <p className={` text-[#6F6F6F] text-sm text-[#6F6F6F`}> Email </p>{" "}
              <span className={` text-base text-lightDark`}>
                <Tooltip title={email}>
                  <div className="truncate">{email}</div>
                </Tooltip>
              </span>
            </div>
            <div className="">
              <p className={` text-[#6F6F6F] text-sm text-[#6F6F6F`}>Phone</p>
              <p className={`text-wrap text-base text-lightDark truncate`}>{phone}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
